import { useDispatch } from 'react-redux'

import { RecentTimeline } from '@/types'
import useLocalStorage from '@/hooks/use-localstorage'
import useSessionComplete from '@/hooks/use-session-complete'

import { getFormattedDateUTC } from './utils'

const useAddRecentMessage = () => {
  const dispatch = useDispatch()
  const isLoggedIn = useSessionComplete()
  const [, setRecentMessages] = useLocalStorage('recentMessages', {})

  const addRecentMessage = (listingId: string, timelineRoomId?: string) => {
    const currentDate = getFormattedDateUTC()
    const newMessage = {
      last_message_date: currentDate,
      timeline_room_id: timelineRoomId
    }
    if (!isLoggedIn) {
      // Add timeline to localStorage
      setRecentMessages((prev: RecentTimeline) => {
        return {
          ...prev,
          [listingId]: newMessage
        }
      })
    }
    // Add timeline to Redux
    dispatch.chat.addRecent({ [listingId]: newMessage })
  }

  const addRecentMessages = (
    listingIds?: string[] | null,
    timelineRoomId?: string
  ) => {
    listingIds?.forEach(listingId => {
      addRecentMessage(listingId, timelineRoomId)
    })
  }

  return { addRecentMessage, addRecentMessages }
}

export default useAddRecentMessage
